import React from 'react'

import Price from './Price'
import getTotal from '../utils/getTotal'

const OrderTotal = props => <Price {...props}>{getTotal(props.order)}</Price>

export default OrderTotal
